/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'ACESWithdrawal' store object.
 * @namespace ACESWithdrawalSelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UAACESWithdrawal';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESWithdrawalSelectors
   */
  static postSubmittedApplicationsApplicationProgramsAcesWithdrawalRequest = state =>
    state[selectors.moduleIdentifier]
      .postSubmittedApplicationsApplicationProgramsAcesWithdrawalRequest.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESWithdrawalSelectors
   */
  static isFetchingPostSubmittedApplicationsApplicationProgramsAcesWithdrawalRequest = state =>
    state[selectors.moduleIdentifier]
      .isFetchingPostSubmittedApplicationsApplicationProgramsAcesWithdrawalRequest.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESWithdrawalSelectors
   */
  static postSubmittedApplicationsApplicationProgramsAcesWithdrawalRequestError = state =>
    state[selectors.moduleIdentifier]
      .postSubmittedApplicationsApplicationProgramsAcesWithdrawalRequestError.payload;
}
